// extracted by mini-css-extract-plugin
export default {"textBox":"TextBox_textBox__pUCZe"};